import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { Button } from '../components/ui/Button';
// הסיסמה המוגדרת (בפרודקשן, זה צריך להיות בצד שרת)
const ADMIN_PASSWORD = 'BeachClub2024!';
export function AdminLogin() {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      // שמירת סטטוס התחברות ב-localStorage
      localStorage.setItem('adminAuthenticated', 'true');
      navigate('/admin');
    } else {
      setError('סיסמה שגויה');
      setPassword('');
    }
  };
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center px-4" dir="rtl" data-id="element-1089" data-mp="1ucaibcm1rouk">
      <div className="max-w-md w-full" data-id="element-1090" data-mp="1pcxxexeqkrum">
        <div className="bg-white rounded-2xl shadow-xl p-8" data-id="element-1091" data-mp="1pbwksoi2nxas">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-1092" data-mp="2hk4708b0f2iv">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4" data-id="element-1093" data-mp="2mkrysw72bne5">
              <Lock className="w-8 h-8 text-blue-600" data-id="element-1094" data-mp="2rd2v7p2lgr1y" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1095" data-mp="2vddaxtg6uvu0">
              כניסה לפאנל ניהול
            </h1>
            <p className="text-gray-500 text-sm" data-id="element-1096" data-mp="1yo4b4mewveu0">
              הזן את הסיסמה כדי לגשת לדף הניהול
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1097" data-mp="23ojo3cva6kbg">
            <div data-id="element-1098" data-mp="27n999rmk965n">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1099" data-mp="27mpq67l6cbq1">
                סיסמה
              </label>
              <div className="relative" data-id="element-1100" data-mp="3j3g0o2wmrppg">
                <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => {
                setPassword(e.target.value);
                setError('');
              }} className="block w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" placeholder="הזן סיסמה" required data-id="element-1101" data-mp="3j2eeb2a5zgsf" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1102" data-mp="1xygx3a7he2vd">
                  {showPassword ? <EyeOff className="w-5 h-5" data-id="element-1103" data-mp="15al2qc5dwn1r" /> : <Eye className="w-5 h-5" data-id="element-1104" data-mp="157gth0d2b148" />}
                </button>
              </div>
              {error && <p className="mt-2 text-sm text-red-600 flex items-center gap-1" data-id="element-1105" data-mp="108dnndp9cqv7">
                  <span className="inline-block w-1 h-1 bg-red-600 rounded-full" data-id="element-1106" data-mp="1f0xlpzxjw85s"></span>
                  {error}
                </p>}
            </div>

            <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition-colors" data-id="element-1107" data-mp="misd8rpixjys">
              כניסה
            </Button>
          </form>

          {/* Info */}
          <div className="mt-6 p-4 bg-blue-50 rounded-lg" data-id="element-1108" data-mp="2t72isc6m2pqy">
            <p className="text-xs text-blue-800 text-center" data-id="element-1109" data-mp="2xy0yb9jrzjt5">
              🔒 הסיסמה הזמנית:{' '}
              <span className="font-mono font-bold" data-id="element-1110" data-mp="2k6mfb2pvbim3">BeachClub2024!</span>
            </p>
            <p className="text-xs text-blue-600 text-center mt-1" data-id="element-1111" data-mp="2k4t6bgrs8max">
              (מומלץ לשנות את הסיסמה בקוד)
            </p>
          </div>
        </div>

        {/* Back to site */}
        <div className="text-center mt-6" data-id="element-1112" data-mp="3bylfy2dyf9l2">
          <a href="/" className="text-sm text-gray-600 hover:text-gray-900 transition-colors" data-id="element-1113" data-mp="3gxewy4sg9ipz">
            ← חזרה לאתר
          </a>
        </div>
      </div>
    </div>;
}